export default "__VITE_ASSET__CyXImq5M__"